<!-- Generic Specialty Intake Fields Section -->
<div *ngIf="hasSpecialtyIntakeData() && appointmentForm" class="mt-4" [formGroup]="appointmentForm">
  <div class="row">
    <div *ngFor="let field of specialtyIntakeFields; let i = index" class="col-lg-12 mb-3">
      <div class="cust--mat--hint" *ngIf="appointmentForm.get(field.fieldName)?.value && appointmentForm.get(field.fieldName)?.value.length > 0">
        Max {{appointmentForm.get(field.fieldName)?.value.length}} / {{getFieldMaxLength(field.fieldName)}} characters
      </div>

      <!-- Text Area Field -->
      <mat-form-field *ngIf="field.type === 'text'" appearance="fill" class="w-100 cah-font-14">
        <mat-label>{{field.label}}</mat-label>
        <textarea
          *ngIf="isLongTextField(field.fieldName)"
          [formControlName]="field.fieldName"
          [readonly]="!editEnabled"
          [maxlength]="getFieldMaxLength(field.fieldName)"
          matInput
          rows="3">
        </textarea>
        <input
          *ngIf="!isLongTextField(field.fieldName)"
          [formControlName]="field.fieldName"
          [readonly]="!editEnabled"
          [maxlength]="getFieldMaxLength(field.fieldName)"
          matInput />
      </mat-form-field>

      <!-- Array Field (for aggression triggers) - Always readonly for now -->
      <div *ngIf="field.type === 'array'" class="array-field">
        <mat-form-field appearance="fill" class="w-100 cah-font-14">
          <mat-label>{{field.label}}</mat-label>
          <input
            [value]="formatArrayValue(field.value)"
            readonly
            matInput />
        </mat-form-field>
      </div>

      <div *ngIf="shouldShowUpdatedWeightConversion(field.fieldName)" class="weight-conversion-preview">
        {{ getUpdatedWeightDisplay(field.fieldName) }}
      </div>
    </div>
  </div>
</div>
